import { render } from "./CreditNote.vue?vue&type=template&id=6a7d10b8&scoped=true"
import script from "./CreditNote.vue?vue&type=script&lang=js"
export * from "./CreditNote.vue?vue&type=script&lang=js"

import "./CreditNote.vue?vue&type=style&index=0&id=6a7d10b8&scoped=true&lang=css"

import exportComponent from "/var/www/eccaplus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a7d10b8"]])

export default __exports__